import { StrictMode, useEffect, useState } from "react";
import { AuditPortal } from "./auditflow/AuditPortal";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./workspace-ui.css";

function Entry() {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const change = () => setHash(window.location.hash);
    window.addEventListener("hashchange", change);
    return () => window.removeEventListener("hashchange", change);
  }, []);
  if (hash.startsWith("#/audit-portal/")) {
    const token = hash.slice("#/audit-portal/".length);
    return <AuditPortal key={token} token={token} />;
  }
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Entry />
  </StrictMode>,
);
